export default {
  releaseInfo: { method: 'get', url: '/game-api/game/releaseInfo' }, // 获取释放信息
  releaseList: { method: 'get', url: '/game-api/game/release' }, // 获取释放记录列表
  newcomerRelease: { method: 'get', url: '/game-api/game/newcomerRelease' }, // 获取新人释放记录列表
  peerTicketInfo: { method: 'get', url: '/game-api/game/peerTicket/info' }, // 获取门票兑换信息
  peerTicketExchange: {
    method: 'post',
    url: '/game-api/game/peerTicket/exchange',
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  }, // 兑换门票
  peerTicketExchangeList: { method: 'get', url: '/game-api/game/peerTicket/exchangeList' }, // 门票兑换记录
  // 游戏托管
  autoBetConfig: { method: 'get', url: '/game-api/game/auto-bet/config' }, // 获取托管配置
  autoBetSaveConfig: {
    method: 'post',
    url: '/game-api/game/auto-bet/config',
    config: { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
  }, // 保存托管配置，使用 JSON 传参
  autoBetEnable: { method: 'post', url: '/game-api/game/auto-bet/enable' }, // 启用托管
  autoBetDisable: { method: 'post', url: '/game-api/game/auto-bet/disable' }, // 关闭托管
  autoBetStatus: { method: 'get', url: '/game-api/game/auto-bet/status' } // 获取托管状态
}
